import { Observable } from 'rxjs';
import { fetchModelListAPI } from '../../api/fetch-functions/model';
import { IModelType } from '../../types/record/model';
import { ListWithPromiseState } from './common/list-with-status';
import {
  fetchIdStreamGenerator,
  fetchListFnGenerator,
  listOfIdFnGenerator,
  oneIdListSetReducerGenerator,
  oneIdListSetStreamGenerator,
  updateStreamGenerator
} from './common/one-id-list';

const fetchSignal$ = fetchIdStreamGenerator();

// 仮引数のリネームのためいったん変数`f`に格納
const f = fetchListFnGenerator(fetchSignal$);
export const fetchModelListOf = (companyId: number) => f(companyId);

/**
 * @description
 * `fetchModelListOf(companyId)` を実行すると
 * `modelListSet$` の該当idの要素を re-fetch する．
 */
const updateModelList$ = updateStreamGenerator(fetchSignal$, fetchModelListAPI);

const modelListSetReducer = oneIdListSetReducerGenerator<IModelType>();

/**
 * @description
 * すべての modelList の集合．必要になったものからfetchして蓄える．
 * 複数のcomponentで共有するため．
 */
const modelListSet$ = oneIdListSetStreamGenerator(
  updateModelList$,
  modelListSetReducer
);

const g = listOfIdFnGenerator(modelListSet$);
export const modelListOf = (
  companyId: number
): Observable<ListWithPromiseState<IModelType>> => {
  fetchModelListOf(companyId);
  return g(companyId);
};
